import { createSlice } from '@reduxjs/toolkit';
import { 
    getFilesThunk, 
    uploadFileThunk, 
    downloadFileThunk, 
    deleteFileThunk 
} from './FileThunks';


const initialState = {
    data: [],
    page: {
        page: 1,
        size: 10,
        totalPage: 1,
        totalSize: 10,
    },
    loading: false,
    error: null,
};

const fileSlice = createSlice({
    name: 'file',
    initialState,
    reducers: {
        funGetFiles(state, action){
            const { fileBundleSeq, fileList } = action.payload;
            state.data = fileList.map((file) =>{
                return{
                    ...file,
                }
            });
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(getFilesThunk.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(getFilesThunk.fulfilled, (state, action) => {
            state.loading = false;
            const { fileBundleSeq, fileList, page } = action.payload || {};
            state.data = (fileList || []).map((file) => ({ ...file }));
            if (page) {
                state.page = {
                    page: page.page ?? state.page.page,
                    size: page.size ?? state.page.size,
                    totalPage: page.totalPage ?? state.page.totalPage,
                    totalSize: page.totalSize ?? state.page.totalSize,
                };
            }
        })
        .addCase(getFilesThunk.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || action.error?.message || '파일 목록 조회 실패';
        });
        builder
        .addCase(uploadFileThunk.pending, (state) => {
            state.error = null;
        })
        .addCase(uploadFileThunk.fulfilled, (state, action) => {
        })
        .addCase(uploadFileThunk.rejected, (state, action) => {
            state.error = action.payload || action.error?.message || '업로드 실패';
        });
        builder
        .addCase(downloadFileThunk.pending, (state) => {
            state.error = null;
        })
        .addCase(downloadFileThunk.fulfilled, (state, action) => {
        })
        .addCase(downloadFileThunk.rejected, (state, action) => {
            state.error = action.payload || action.error?.message || '다운로드 실패';
        });
        builder
        .addCase(deleteFileThunk.pending, (state) => {
            state.error = null;
        })
        .addCase(deleteFileThunk.fulfilled, (state, action) => {
            const deletedFileSeq = action.meta?.arg;
            if (deletedFileSeq != null) {
                state.data = state.data.filter(f => f.fileSeq !== deletedFileSeq);
            }
        })
        .addCase(deleteFileThunk.rejected, (state, action) => {
            state.error = action.payload || action.error?.message || '삭제 실패';
        });
    },
});

export const fileActions = fileSlice.actions;
export default fileSlice.reducer;